/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRank2Filled = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-2.365-7.4 1.82-2c.353-.387.627-.7.82-.94.2-.247.34-.453.42-.62.08-.173.12-.333.12-.48 0-.607-.383-.91-1.15-.91-.54 0-1.153.183-1.84.55V8.86c.313-.16.65-.283 1.01-.37a4.33 4.33 0 0 1 1.07-.14c.773 0 1.373.177 1.8.53.427.353.64.857.64 1.51 0 .267-.053.533-.16.8a4.168 4.168 0 0 1-.53.9c-.24.327-.567.72-.98 1.18l-1.01 1.11h2.7v1.27h-4.73V14.6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRank2Filled as Rank2Filled };
